import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { toast } from "sonner";

export default function FacebookCallback() {
  const navigate = useNavigate();
  const { setAuth } = useAuthStore();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (code) {
      fetch(`https://megamart.co.ke/backend/auth/facebook/callback?code=${code}`)
        .then(res => res.json())
        .then(data => {
          if (data.session_token) {
            setAuth(data.session_token, data.user);
            toast.success(`Welcome ${data.user.name}!`);
            navigate("/");
          } else {
            toast.error("Facebook login failed");
          }
        })
        .catch(() => toast.error("Error during Facebook login"));
    }
  }, [navigate, setAuth]);

  return <p>Completing Facebook login...</p>;
}
